import { useEffect } from 'react'
import Link from 'next/link'
import useCustomer from '@framework/customer/use-customer'
import commerce from '@lib/api/commerce'
import { Layout, SEO } from '@components/common'
import { Container, Text } from '@components/ui'
import { getGlobalContentContext } from '@drf/getGlobalContentContext'
import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { getPageContext } from '@drf/getPageContext'
import { useUI } from '@components/ui/context'
import { PostsView } from '@components/blog'
import { useGlobalContentContext } from '@context/GlobalContentContext'

export async function getStaticProps({
  preview,
  locale,
  locales,
}: GetStaticPropsContext) {
  const config = { locale, locales }
  const productsPromise = commerce.getAllProducts({
    variables: { first: 50 },
    config,
    preview,
    // Saleor provider only
    ...({ featured: true } as any),
  })
  const pagesPromise = commerce.getAllPages({ config, preview })

  const blogPagesPromise = commerce.getAllPosts({ config, preview })

  //   const siteInfoPromise = commerce.getSiteInfo({ config, preview })
  const { products } = await productsPromise
  const { pages } = await pagesPromise
  //   const  siteInfo  = await siteInfoPromise
  const page = pages.filter(
    (page) => page.name.toLowerCase() === 'the logbook'
  )[0]
  const { posts } = await blogPagesPromise

  const global = await getGlobalContentContext()

  return {
    props: {
      products,
      pages,
      global,
      posts,
      page,
    },
    revalidate: 60,
  }
}

export default function Blog({
  products,
  global,
  page,
  posts,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const { setData } = useGlobalContentContext()

  useEffect(() => {
    setData(global)
  }, [global, setData])

  const { setPageTheme, setContainerFullWidth } = useUI()

  useEffect(() => {
    setContainerFullWidth()
    setPageTheme('DARK')
  }, [])

  return (
    <>
      <PostsView data={posts} />
      <SEO
        title="The Logbook | LoreOne"
        description=""
        openGraph={{
          type: 'website',
          title: 'The Logbook',
          description: 'The Logbook',
          images: [
            {
              url: posts[0].thumbnail_path,
              width: '800',
              height: '600',
              alt: '',
            },
          ],
        }}
      />
    </>
  )
}

Blog.Layout = Layout
